module.exports = __webpack_public_path__ + "img/ApprovedByEdith.62d4106a.svg";